import { IBanner, IBannerItem, ICommunityBannerConfig } from '../interface/ICommunityBanner';
import axios from 'axios';
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default class Index {
    constructor(_config: ICommunityBannerConfig) {
        // console.log('-------Community Banner START-------', _config);
        if (location.hostname === '' || location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
            this._fetchDummyList(_config.dummyData as IBanner);
        } else this.fetchBannerList(_config.apiDomain + _config.contiTopBannerApi);
    }

    // 더미 데이터 가져오기
    _fetchDummyList(data: IBanner) {
        if (!data.isActive) return;
        this.createBanner(data.bannerList);
    }

    async fetchBannerList(_api: string) {
        try {
            const { data } = await axios.get(`${_api}`);
            if (!data) return;
            const parseData: IBanner = JSON.parse(data.jsonData);
            if (!parseData.isActive) return;
            this.createBanner(parseData.bannerList);
        } catch (error) {
            console.log(error);
        }
    }

    createBanner(bannerList: IBannerItem[]): void {
        const boardTopBannerIndex = document.querySelector('.board-top-banner-index');
        if (!(boardTopBannerIndex instanceof Element)) return;

        if (bannerList.length <= 1) {
            this.appendBannerList(
                boardTopBannerIndex,
                bannerList,
                `<div class="board-top-banner"></div>`,
                '.board-top-banner'
            );
        } else {
            this.appendBannerList(
                boardTopBannerIndex,
                bannerList,
                `<div class="board-top-banner swiper-container">
                    <div class="swiper-wrapper"></div>
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-pagination"></div>
                </div>`,
                '.board-top-banner .swiper-wrapper'
            );
            this.setSwiper();
        }
    }

    appendBannerList(
        boardTopBannerIndex: Element,
        bannerList: IBannerItem[],
        containerElement: string,
        wrapperElement: string
    ): void {
        boardTopBannerIndex.insertAdjacentHTML('beforeend', containerElement);
        const bannerSwiperWrapper = document.querySelector(wrapperElement);

        bannerList.forEach((bannerItem: IBannerItem) => {
            let bannerItemElement = `
                <div class="item swiper-slide">
                    <a href="${bannerItem.url}" class="link">
                        <img src="${bannerItem.img_m}" class="img-m" alt="">
                        <img src="${bannerItem.img_pc}" class="img-pc" alt="">
                    </a>
                </div>`;
            bannerSwiperWrapper?.insertAdjacentHTML('beforeend', bannerItemElement);
        });
    }

    setSwiper(): void {
        new Swiper('.board-top-banner', {
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            centeredSlides: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            breakpoints: {
                960: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.board-top-banner .swiper-button-next',
                prevEl: '.board-top-banner .swiper-button-prev',
            },
            pagination: {
                el: '.board-top-banner .swiper-pagination',
                clickable: true,
            },
        });
    }
} // end of class
